import { ApiDocs } from '../../components/docs/ApiDocs';
import { apiFetch, INTERIOR_API_BASE } from '../../utils/api';

/**
 * Interior's integration reference, rendered from the spec it serves itself.
 * See {@link ../../components/docs/ApiDocs.ApiDocs}.
 */
const fetchSpec = (path: string) => apiFetch(path, { app: 'interior' });

export function InteriorDocsPage() {
  return <ApiDocs apiBase={INTERIOR_API_BASE} fetchSpec={fetchSpec} />;
}
